export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f1f8ad32087079b675e2c5918411ea281f3aa018a&name=sendEvent!'